document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-header]')
  const headerLogo = document.querySelector('[data-header-logo]')
  const bar = document.querySelector('[data-header-bar]')
  const panel = document.querySelector('[data-nav-panel]')
  const toggles = document.querySelectorAll('[data-nav-toggle]')
  const desktopQuery = window.matchMedia('(min-width: 1024px)')
  const xlQuery = window.matchMedia('(min-width: 1200px)')

  const CURTAIN = 0.85

  const revealAt = (el) => {
    const ratio = Math.min(Math.max(el.getBoundingClientRect().top / window.innerHeight, 0), 1)
    return ratio * CURTAIN
  }

  // Cart count badge (kept outside the blend layer)
  const cartBubble = document.getElementById('cart-bubble')
  const cartCount = document.querySelector('[data-cart-count]')

  const getHeaderItems = () => {
    const navLinks = document.querySelectorAll('nav .nav-link')
    const headerIcons = document.querySelectorAll('[data-header-icon]')
    return [headerLogo, ...navLinks, ...headerIcons, cartCount].filter(Boolean)
  }

  const revealHeaderItems = () => {
    if (!window.gsap) return
    const items = getHeaderItems()
    if (!items.length) return

    const { gsap } = window
    gsap.set(items, { autoAlpha: 0, y: -20 })
    gsap.to(items, {
      autoAlpha: 1,
      y: 0,
      duration: 0.8,
      ease: 'power3.out',
      clearProps: 'transform',
      delay: 0.3,
    })
  }

  const syncCartCount = () => {
    if (!cartBubble || !cartCount) return

    const source = cartBubble.querySelector('[data-cart-count-value]')
    const rect = source?.getBoundingClientRect()

    if (!source || !rect || !rect.width) {
      cartCount.style.display = 'none'
      return
    }

    cartCount.textContent = source.textContent.trim()
    cartCount.style.display = 'flex'
    cartCount.style.top = `${rect.top}px`
    cartCount.style.left = `${rect.left}px`
    cartCount.style.width = `${rect.width}px`
    cartCount.style.height = `${rect.height}px`
  }

  if (cartBubble && cartCount) {
    syncCartCount()
    new MutationObserver(syncCartCount).observe(cartBubble, { childList: true, subtree: true })
    window.addEventListener('resize', syncCartCount, { passive: true })
  }

  if (header && panel && toggles.length) {
    const categories = panel.querySelectorAll('[data-nav-category]')
    const rootItems = panel.querySelectorAll('[data-nav-root-item]')
    const media = panel.querySelector('[data-nav-media]')
    const navVideo = panel.querySelector('[data-nav-video]')
    const drill = panel.querySelector('[data-nav-drill]')
    const back = header.querySelector('[data-nav-back]')
    const rootNav = panel.querySelector('[data-nav-root]')
    const categoriesNav = panel.querySelector('[data-nav-categories]')
    const defaultChrome = header.querySelectorAll('[data-header-default]')
    const shopChrome = header.querySelectorAll('[data-header-shop]')

    const playNavVideo = () => {
      if (!navVideo) return
      navVideo.muted = true
      navVideo.play()?.catch(() => {})
    }

    const pauseNavVideo = () => {
      if (!navVideo) return
      navVideo.pause()
    }

    const isOpen = () => header.getAttribute('data-state') === 'open'
    const isShopOpen = () => header.getAttribute('data-shop') === 'open'

    const setExpanded = (state) => {
      toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', String(state)))
    }

    let navTl = null
    let shopTl = null

    const itemInners = (items) =>
      Array.from(items)
        .map((item) => item.querySelector('[data-nav-item-inner]') || item)
        .filter(Boolean)

    const resetShopChrome = () => {
      if (!window.gsap) return
      const { gsap } = window
      gsap.set(defaultChrome, { clearProps: 'opacity,visibility,transform' })
      gsap.set(shopChrome, { autoAlpha: 0, clearProps: 'transform' })
      if (rootNav) gsap.set(rootNav, { clearProps: 'opacity,visibility,transform' })
      if (categoriesNav) gsap.set(categoriesNav, { autoAlpha: 0, clearProps: 'transform' })
    }

    const closeShop = ({ animate = true } = {}) => {
      if (!isShopOpen() && !shopTl) return

      if (!window.gsap || desktopQuery.matches || !animate) {
        header.removeAttribute('data-shop')
        if (shopTl) {
          shopTl.kill()
          shopTl = null
        }
        resetShopChrome()
        return
      }

      const { gsap } = window
      const inners = itemInners(categories)

      if (shopTl) shopTl.kill()

      gsap.set(defaultChrome, { autoAlpha: 0, y: 8 })
      header.removeAttribute('data-shop')

      shopTl = gsap.timeline({
        defaults: { ease: 'power3.inOut' },
        onComplete: () => {
          resetShopChrome()
          shopTl = null
        },
      })

      if (inners.length) {
        shopTl.to(inners, { yPercent: 40, autoAlpha: 0, duration: 0.35, stagger: 0.04 }, 0)
      }
      if (categoriesNav) {
        shopTl.to(categoriesNav, { autoAlpha: 0, x: 24, duration: 0.4 }, 0)
      }
      shopTl.to(shopChrome, { autoAlpha: 0, y: -6, duration: 0.35 }, 0)
      shopTl.to(defaultChrome, { autoAlpha: 1, y: 0, duration: 0.45 }, 0.12)
      if (rootNav) {
        shopTl.fromTo(rootNav, { autoAlpha: 0, x: -20 }, { autoAlpha: 1, x: 0, duration: 0.45 }, 0.12)
      }
    }

    const openShop = () => {
      if (desktopQuery.matches) return

      header.setAttribute('data-shop', 'open')
      if (!window.gsap) return

      const { gsap } = window
      const inners = itemInners(categories)

      if (shopTl) shopTl.kill()
      shopTl = gsap.timeline({ defaults: { ease: 'power3.out' } })

      shopTl.to(defaultChrome, { autoAlpha: 0, y: -8, duration: 0.35 }, 0)
      if (rootNav) {
        shopTl.to(rootNav, { autoAlpha: 0, x: -20, duration: 0.4 }, 0)
      }

      gsap.set(shopChrome, { autoAlpha: 0, y: 10 })
      shopTl.to(shopChrome, { autoAlpha: 1, y: 0, duration: 0.45 }, 0.15)

      if (categoriesNav) gsap.set(categoriesNav, { autoAlpha: 1, x: 0 })
      if (inners.length) {
        gsap.set(inners, { yPercent: 110, autoAlpha: 0 })
        shopTl.to(inners, { yPercent: 0, autoAlpha: 1, duration: 0.65, stagger: 0.12 }, 0.22)
      }
    }

    const lockScroll = () => {
      document.documentElement.style.overflow = 'hidden'
      if (window.lenis) window.lenis.stop()
    }

    const unlockScroll = () => {
      document.documentElement.style.overflow = ''
      if (window.lenis) window.lenis.start()
    }

    const open = () => {
      if (bar) bar.style.transition = 'color 0.1s ease-out'
      header.setAttribute('data-state', 'open')
      document.dispatchEvent(new CustomEvent('header:update-blend'))
      setExpanded(true)
      lockScroll()
      playNavVideo()

      if (!window.gsap) return

      const { gsap } = window
      const isDesktop = desktopQuery.matches

      if (navTl) navTl.kill()

      gsap.set(panel, { display: 'block', autoAlpha: 1, clipPath: 'inset(0 0 100% 0)' })

      navTl = gsap.timeline({ defaults: { ease: 'power3.out', clearProps: 'transform' } })
      navTl.to(panel, { clipPath: 'inset(0 0 0% 0)', duration: CURTAIN, ease: 'power3.inOut' }, 0)

      if (media) {
        gsap.set(media, { y: 32 })
        navTl.to(media, { y: 0, duration: 0.9 }, isDesktop ? 0 : Math.max(0, revealAt(media) - 0.1))
      }

      const revealItems = isDesktop ? categories : rootItems
      const inners = itemInners(revealItems)

      if (inners.length) {
        const start = isDesktop ? 0.28 : Math.max(0.22, revealAt(revealItems[0]) - 0.08)

        gsap.set(inners, { yPercent: 120, autoAlpha: 0 })
        navTl.to(
          inners,
          {
            yPercent: 0,
            autoAlpha: 1,
            duration: 0.7,
            stagger: isDesktop ? 0.16 : 0.14,
          },
          start,
        )
      }
    }

    const close = () => {
      pauseNavVideo()
      setExpanded(false)
      closeShop({ animate: false })
      if (bar) bar.style.transition = 'color 0.2s ease-out 0.3s'
      header.removeAttribute('data-state')
      document.dispatchEvent(new CustomEvent('header:update-blend'))

      const reset = () => {
        unlockScroll()
        if (bar) bar.style.transition = ''
        if (window.gsap) {
          window.gsap.set(panel, { clearProps: 'display,opacity,visibility,clipPath' })
          window.gsap.set(itemInners([...rootItems, ...categories]), {
            clearProps: 'transform,opacity,visibility',
          })
        }
      }

      if (!window.gsap) {
        reset()
        return
      }

      const { gsap } = window
      if (navTl) navTl.kill()
      navTl = gsap.timeline({ onComplete: reset })
      navTl.to(panel, { clipPath: 'inset(0 0 100% 0)', duration: 0.5, ease: 'power3.inOut' })
    }

    toggles.forEach((toggle) => {
      toggle.addEventListener('click', (event) => {
        event.preventDefault()
        isOpen() ? close() : open()
      })
    })

    if (drill) {
      drill.addEventListener('click', (event) => {
        event.preventDefault()
        openShop()
      })
    }

    if (back) {
      back.addEventListener('click', (event) => {
        event.preventDefault()
        closeShop()
      })
    }

    xlQuery.addEventListener('change', (event) => {
      if (event.matches) closeShop({ animate: false })
    })

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isOpen()) close()
    })
  }

  // Pin + blend on scroll
  const homeHero = document.querySelector('[data-home-hero-section]')

  if (bar) {
    const createBlendBar = () => {
      const nextBar = bar.cloneNode(true)
      nextBar.removeAttribute('data-header-bar')
      nextBar.setAttribute('data-header-blend-bar', '')
      nextBar.setAttribute('aria-hidden', 'true')
      nextBar.classList.remove('z-[999]')
      nextBar.classList.add('text-cream-100')
      nextBar.style.cssText = 'z-index:998;mix-blend-mode:difference;pointer-events:none;opacity:0'

      nextBar.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'))
      nextBar.querySelectorAll('shopify-account, [data-nav-back]').forEach((el) => el.remove())

      const logo = nextBar.querySelector('[data-header-logo]')
      const center = logo?.closest('.absolute.inset-0')
      if (center) {
        Array.from(center.children).forEach((child) => {
          if (!child.contains(logo)) child.remove()
        })
      }

      nextBar.querySelectorAll('a, button, input, textarea, select').forEach((el) => {
        el.setAttribute('tabindex', '-1')
        el.removeAttribute('href')
        el.setAttribute('aria-hidden', 'true')
      })

      nextBar
        .querySelectorAll(
          '[data-header-logo], [data-header-icon], [data-header-link], [data-header-default], [data-header-shop], [data-nav-toggle], [data-shop-toggle]',
        )
        .forEach((el) => {
          el.classList.remove('opacity-0')
          ;[
            'data-header-logo',
            'data-header-icon',
            'data-header-link',
            'data-header-default',
            'data-header-shop',
            'data-nav-toggle',
            'data-shop-toggle',
          ].forEach((attr) => el.removeAttribute(attr))
        })

      bar.parentNode.insertBefore(nextBar, bar)
      return nextBar
    }

    const blendBar = createBlendBar()
    const headerSlideEls = [bar, blendBar, cartCount].filter(Boolean)
    let blendAmount = -1

    const applyBlendAmount = (amount) => {
      const blended = header?.getAttribute('data-state') === 'open' ? 0 : amount
      if (blended === blendAmount) return
      blendAmount = blended
      bar.style.opacity = String(1 - blended)
      blendBar.style.opacity = String(blended)
    }

    const updateBlend = () => {
      const vh = window.innerHeight

      if (!homeHero) {
        const range = Math.max(120, vh * 0.15)
        applyBlendAmount(Math.min(1, Math.max(0, window.scrollY / range)))
        return
      }

      const seam = bar.getBoundingClientRect().bottom
      const heroBottom = homeHero.getBoundingClientRect().bottom
      const start = seam - Math.max(80, vh * 0.12)
      const end = seam + Math.max(140, vh * 0.22)
      const progress = (heroBottom - start) / (end - start)

      applyBlendAmount(1 - Math.min(1, Math.max(0, progress)))
    }

    document.addEventListener('header:hide', (event) => {
      if (!window.gsap || xlQuery.matches) return

      const { gsap } = window
      const duration = event.detail?.duration ?? 1.2

      bar.style.pointerEvents = 'none'

      gsap.to(headerSlideEls, {
        y: -bar.getBoundingClientRect().bottom,
        duration,
        ease: 'power3.inOut',
        overwrite: true,
      })
    })

    document.addEventListener('header:show', () => {
      if (!window.gsap || xlQuery.matches) return

      window.gsap.set(headerSlideEls, { y: 0, overwrite: true })
      bar.style.pointerEvents = ''
      revealHeaderItems()
    })

    xlQuery.addEventListener('change', (event) => {
      if (!event.matches || !window.gsap) return
      window.gsap.set(headerSlideEls, { y: 0, overwrite: true })
      bar.style.pointerEvents = ''
    })

    let ticking = false
    const onScroll = () => {
      if (ticking) return
      ticking = true
      requestAnimationFrame(() => {
        updateBlend()
        ticking = false
      })
    }

    updateBlend()
    window.addEventListener('scroll', onScroll, { passive: true })
    window.addEventListener('resize', onScroll, { passive: true })
    if (window.lenis) window.lenis.on('scroll', updateBlend)
    document.addEventListener('header:update-blend', updateBlend)

    document.documentElement.style.setProperty('--header-height', `${bar.offsetHeight}px`)
  }

  revealHeaderItems()
})
